(() => {
  if (customElements.get('manicken-hero-slider')) return;

  class ManickenHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-m-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-m-hero-dot]'));
      this.current = 0;
      this.timer = null;

      if (this.slides.length <= 1) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.dataset.slideIndex || 0);
          this.goTo(index);
          this.restartAutoplay();
        });
      });

      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());

      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    goTo(index) {
      if (index < 0 || index >= this.slides.length || index === this.current) return;

      this.slides[this.current].classList.remove('is-active');
      this.slides[this.current].setAttribute('aria-hidden', 'true');

      if (this.dots[this.current]) {
        this.dots[this.current].classList.remove('is-active');
        this.dots[this.current].removeAttribute('aria-current');
      }

      this.current = index;

      this.slides[this.current].classList.add('is-active');
      this.slides[this.current].removeAttribute('aria-hidden');

      if (this.dots[this.current]) {
        this.dots[this.current].classList.add('is-active');
        this.dots[this.current].setAttribute('aria-current', 'true');
      }
    }

    next() {
      const nextIndex = (this.current + 1) % this.slides.length;
      this.goTo(nextIndex);
    }

    startAutoplay() {
      if (this.dataset.autoplay !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stopAutoplay();

      const interval = Number(this.dataset.interval || 5000);
      this.timer = window.setInterval(() => this.next(), interval);
    }

    stopAutoplay() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  customElements.define('manicken-hero-slider', ManickenHeroSlider);
})();
